import React from 'react'

type Props = {
    className?: string
    enabled?: boolean
}

export const CaptionsIcon = (props: Props) => {
    const { className = "w-5 h-5", enabled = false } = props

    if (enabled) {
        return (
            <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
                <rect width="18" height="14" x="3" y="5" rx="2" ry="2"/>
                <path d="M7 15h4M15 15h2M7 11h2M13 11h4"/>
            </svg>
        )
    } else {
        return (
            <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
                <path d="M10.5 5H19a2 2 0 0 1 2 2v8.5"/>
                <path d="M17 11h-.5"/>
                <path d="M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2"/>
                <path d="m2 2 20 20"/>
                <path d="M7 11h4"/>
                <path d="M7 15h2.5"/>
            </svg>
        )
    }
}
